export default __webpack_public_path__ + "static/media/image.0b06d81a.svg";